import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { ICollapsableNavItem } from '../collapsable-nav.component';

@Component({
  selector: 'app-collapsable-nav-card',
  templateUrl: './collapsable-nav-card.component.html',
  imports: [NzCardModule, NzIconModule, RouterLink],
})
export class CollapsableNavCardComponent {
  public item = input.required<ICollapsableNavItem>();
}